module.exports = __webpack_public_path__ + "img/3_114.3ab68e74.png";